<template>
  <div class="settled-container">
    <template v-if="isCheckingSkill">
      <div class="skill-checking">
        <img src="~@/assets/images/skill-validating.png">
        <p>
          <span>{{$t('upgrade_page_views_settled_in_before_settled_1129')}}</span>
          <span>{{$t('upgrade_page_views_settled_in_before_settled_1130')}}</span>
          <span>{{$t('upgrade_page_views_settled_in_before_settled_1131')}}</span>
          <span>{{$t('upgrade_page_views_settled_in_before_settled_1132')}}</span>
        </p>
      </div>
    </template>
    <div v-else>
      <img class="left-img" src="~@/assets/images/settle-img.png">
      <img class="right-img" src="~@/assets/images/settle-img.png">
      <div class="imgs-container">
        <div>
          <img src="~@/assets/images/settle-bc1.png">
          <img src="~@/assets/images/settle-bc2.png">
          <img src="~@/assets/images/settle-bc3.png">
          <img src="~@/assets/images/settle-bc4.png">
        </div>
      </div>
      <div class="content">
        <div class="title1">{{$t('upgrade_page_views_settled_in_before_settled_1133')}}</div>
        <div class="title2">{{$t('upgrade_page_views_settled_in_before_settled_1134')}}</div>

        <div class="text-container">
          <button class="become-b" @click="openSellte">{{$t('upgrade_page_views_settled_in_before_settled_1135')}}</button>
          <button class="become-app" @click="openToApp">{{$t('upgrade_page_views_settled_in_before_settled_1135')}}</button>
          <div class="rules">
            <div :class="['should-select', isSelected && 'selected']" @click="isSelected = !isSelected" />
            <span>{{$t('upgrade_page_views_settled_in_before_settled_1136')}}</span>
            <div class="read-rule pointer" @click="jumpPage('/rules')">{{$t('upgrade_page_views_settled_in_before_settled_1137')}}</div>
            <div class="read-rule pointer" @click="jumpPage('/privacy')">{{$t('upgrade_page_views_settled_in_before_settled_1138')}}</div>  
          </div>
          <div class="text-title">
            <img class="img1" src="~@/assets/images/settle-img.png">
            <span>{{$t('upgrade_page_views_settled_in_before_settled_1139')}}</span>
            <img class="img2" src="~@/assets/images/settle-img2.png">
          </div>
          <div class="text">{{$t('upgrade_page_views_settled_in_before_settled_1140')}}</div>
          <div class="text">{{$t('upgrade_page_views_settled_in_before_settled_1141')}}</div>
          <div class="text">{{$t('upgrade_page_views_settled_in_before_settled_1142')}}</div>
          <div class="text">{{$t('upgrade_page_views_settled_in_before_settled_1143')}}</div>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="100%"
      custom-class="dialog-clear-style"
      >
      <div class="btn-dialog">
        <h3>{{$t('upgrade_page_views_settled_in_before_settled_1144')}}</h3>
        <h4>{{$t('upgrade_page_views_settled_in_before_settled_1145')}}</h4>
        <button class="btn-app" @click="downloadApp">{{$t('upgrade_page_views_settled_in_before_settled_1146')}}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isSelected: false,
      pageLoaded: false,
      isCheckingSkill: false,
      dialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    userInfo() {
      this.isPlayer()
    }
  },
  created() {
    this.isPlayer()
    this.getSkillWithValidate()
  },
  methods: {
    isPlayer() {
      if (this.userInfo && this.userInfo.userKind === 'Player') {
        this.$router.replace({
          path: '/'
        })
      }
    },
    // web移动菜单
    downloadApp() {
      this.$util.jumpAppStore()
    },
    openToApp() {
      this.dialogVisible = true
    },
    getSkillWithValidate() {
      const { userInfo } = this.$store.state.app
      this.$store.dispatch('app/getGamesList').then(({ allGames }) => {
        if (allGames) {
          this.pageLoaded = true
          if (userInfo && userInfo.userKind !== 'Player') {
            for (var attr in allGames) {
              for (var i in allGames[attr]) {
                if (allGames[attr][i].status === 'Checking') {
                  this.isCheckingSkill = true
                  return
                }
              }
            }
          }
        }
      })
    },
    jumpPage(path) {
      this.$router.push(path)
    },
    openSellte() {
      if (!this.pageLoaded) return
      if (!this.isSelected) {
        this.$message.error(i18n.t('upgrade_page_views_settled_in_before_settled_1147'))
        return
      }
      this.$confirm({
        content: i18n.t('upgrade_page_views_settled_in_before_settled_1148'),
        title: '',
        showClose: false,
        confirmButtonText: i18n.t('upgrade_page_views_settled_in_before_settled_1149'),
        cancelButtonText: i18n.t('upgrade_page_views_settled_in_before_settled_1150'),
      }).then(() => {
        this.$router.push('/first-settle')
      })
      .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
  .skill-checking {
    padding-top: 70px;
    display: flex;
    justify-content: center;
    height: 500px !important;
    background: white !important;
    img {
      display: block;
      width: 230px;
      height: 104px;
      margin-right: 80px;
    }
    p {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      color: #333333;
      span {
        margin-bottom: 5px;
        &:first-child {
          font-weight: 500;
          line-height: 31px;
          font-size: 22px;
          color: #333;
          margin-bottom: 15px;
          text-align: center;
        }
      }
    }
  }
  @keyframes jumpUp {
    0% {
      top: 730px;
    }
    50% {
      top: 630px;
    }
    100% {
      top: 730px;
    }
  }
  @keyframes jumpUpResever {
    0% {
      right: 0px;
    }
    50% {
      right: -50px;
    }
    100% {
      right: 0px;
    }
  }
  .settled-container {
    >div {
      height: 938px;
      background: #E5E5E5;
      position: relative;
    }
    .imgs-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      font-size: 0;
      >div {
        padding: 0 60px;
      }
      img {
        width: 25%;
      }
    }
    .content {
      width: 100%;
      height: 100%;
      display: flex;
      position: relative;
      z-index: 3;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      .title1 {
        font-weight: 600;
        font-size: 40px;
        line-height: 56px;
        text-align: center;
        color: #FFFFFF;
        text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      }
      .title2 {
        text-align: center;
        color: #FFFFFF;
        margin-bottom: 150px;
        font-weight: 600;
        font-size: 50px;
        line-height: 70px;
        text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.55);
      }
      .become-b {
        width: 171px;
        height: 60px;
        line-height: 60px;
        border-radius: 59px;
        font-weight: 600;
        font-size: 16px;
        text-align: center;
        @include button-yellow
      }
      .rules {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 13px 0 40px;
        font-size: 14px;
        line-height: 20px;
        color: #000;
        text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.4);

        .should-select {
          width: 17px;
          height: 17px;
          box-sizing: border-box;
          border: 1.5px solid #666666;
          box-sizing: border-box;
          background: rgba(0, 0, 0, 0.1);
          box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          margin-right: 6px;
        }
        .selected {
          border: none;
          background: url('~@/assets/images/rule-checked.png') no-repeat center center / 100%;
        }
        .read-rule {
          color: #000;
          margin-left: 10px;
        }
      }
    }
    .left-img {
      position: absolute;
      height: 78px;
      left: 0px;
      top: 730px;
      transform: rotate(-25deg);
      animation: jumpUp 5s infinite;
      z-index: 5;
    }
    .right-img {
      position: absolute;
      height: 108px;
      right: 0;
      top: 282px;
      transform: rotate(-135deg); 
      animation: jumpUpResever 4s infinite;
      z-index: 5;
    }
  }
  .text-container {
    padding-top: 20px;
    width: 80%;
    height: auto;
    padding-bottom: 20px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 60px; 
    .text-title {
      @include flex(center, center);
      margin: 0px 0  35px;
      span {
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        color: #333333;
        margin: 0 5px 0 11px;
        white-space: nowrap;
      }
      img {
        height: 34px;
      }
      .img2 {
        transform: rotate(15deg)
      }
    }
    .text {
      font-size: 18px;
      line-height: 35px;
      text-align: center;
      color: #333333;
    }
  }
  @media screen and (min-width: 600px) {
    .become-app {
      display: none;
    }
  }
  @media screen and (max-width: 599px) {
    .settled-container {
      min-height: auto!important;
      background: #FFFFFF;
      >div {
        height: auto;
      }
      .imgs-container {
        position: absolute;
        top: 0;
        left: 0;
        height: 234px;
        width: 100%;
        font-size: 0;
        >div {
          height: 100%;
          padding: 0;
          background: url('~@/assets/images/settle-bc.png') no-repeat left center;
          background-size: cover;
        }
        img {
          display: none;
        }
      }
      .content {
        height: auto;
        .title1 {
          margin-top: 63px;
          font-size: 20px;
          line-height: 28px;
        }
        .title2 {
          margin-bottom: 150px;
          font-size: 28px;
          line-height: 39px;
        }
        .become-b {
          display: none;
        }
        .become-app {
          width: 104px;
          height: 32px;
          line-height: 32px;
          border-radius: 50px;
          font-weight: 500;
          font-size: 12px;
          margin-bottom: 44px;
          @include button-yellow
        }
        .rules {
          display: none;
        }
      }
      .left-img {
        display: none;
      }
      .right-img {
        display: none;
      }
    }
    .text-container {
      width: 100%;
      height: 362px;
      margin-bottom: 0;
      padding-bottom: 0;
      .text-title {
        margin: 30px 0  12.5px;
        span {
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          margin: 0 27px 0 29px;
        }
        img {
          height: 34px;
        }
        .img2 {
          transform: rotate(15deg)
        }
      }
      .text {
        font-size: 14px;
        line-height: 30px;
        margin: 0 30px;
      }
      .text:nth-last-of-type(1){
        margin-top: 16px;
        font-weight: 500;
        font-size: 14px;
        line-height: 30px;
        color: #222C43;
      }
    }
  }
  /deep/ .el-dialog {
    position: absolute;
    bottom: 0;
    margin: 0;
    .el-dialog__headerbtn{
      top: 18px;
    }
  }
  .btn-dialog{
    padding: 36px 16px 28px;
    background: #FFFFFF;
    h3{
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #222C43;
    }
    h4{
      margin-top: 8px;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #636D86;
    }
    .btn-app{
      @include button-yellow;
      width: 100%;
      margin-top: 28px;
      height: 48px;
      border-radius: 50px;
      font-weight: 500;
      font-size: 16px;
      color: #222C43;
    }
  }
</style>
